module.exports = __webpack_public_path__ + "static/media/pro-tip-pricing.54798b28.jpg";